import Event from '../../components/event';
import { resetEvent } from '../../actions';
import { connect } from 'react-redux';

import { getEventActionLoading, getEventActionText } from '../../reducers';

const mapStateToProps = state => ({
    eventActionText: getEventActionText(state),
    eventActionLoading: getEventActionLoading(state)
});

const mapDispatchToProps = dispatch => ({
    resetEvent: () => dispatch(resetEvent())
});

export default connect(mapStateToProps, mapDispatchToProps)(Event);



// WEBPACK FOOTER //
// ./src/containers/event/index.js